import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ApolloError } from 'apollo-client';
import ReportGameIssue from 'containers/ReportGameIssue';
import { toggleChat, setUserData, setCallbacks } from 'utils/zopim';
import { getUserData } from 'utils/graphQLFunctions';
import supportIconImage from './icon-support.svg';

class SupportIcon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      supportOpen: false,
      reportGameIssueFormOpen: false
    };

    this.toggleSupport = this.toggleSupport.bind(this);
    this.closeSupport = this.closeSupport.bind(this);
    this.openSupport = this.openSupport.bind(this);
    this.openReportGameIssueForm = this.openReportGameIssueForm.bind(this);
  }

  componentDidMount() {
    setCallbacks(this.closeSupport, this.openSupport);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data.user !== this.props.data.user) {
      setUserData(nextProps.data.user);
    }
  }

  closeSupport() {
    this.setState({
      supportOpen: false,
      reportGameIssueFormOpen: false
    });
  }

  openSupport() {
    this.setState({
      supportOpen: true,
      reportGameIssueFormOpen: false
    });
  }

  openReportGameIssueForm() {
    if (this.state.supportOpen && !this.state.reportGameIssueFormOpen) {
      toggleChat();
      this.setState({
        supportOpen: true,
        reportGameIssueFormOpen: true
      });
    }
  }

  toggleSupport() {
    if (this.state.reportGameIssueFormOpen) {
      this.closeSupport();
    } else {
      toggleChat();
    }
  }

  render() {
    return (
      <div className="support-icon-container">
        <ReportGameIssue
          supportOpen={this.state.supportOpen}
          formOpen={this.state.reportGameIssueFormOpen}
          close={this.closeSupport}
          open={this.openReportGameIssueForm}
        />
        <a onClick={this.toggleSupport}>
          <img alt="Support Chat Bubbles" src={supportIconImage} />
        </a>
      </div>
    );
  }
}

SupportIcon.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.instanceOf(ApolloError),
      PropTypes.instanceOf(Error)
    ]),
    user: PropTypes.object
  })
};

export default getUserData()(SupportIcon);



// WEBPACK FOOTER //
// ./src/components/Footer/SupportIcon.js